<ejs-dialog
	#modal
	(close)="closeModal(false)"
	[showCloseIcon]="!isVoiding"
	[closeOnEscape]="!isVoiding"
	cssClass="modal-md"
	[attr.data-test-id]="'practicePayVoidPaymentModal'">
	<ng-template #header>
		<div class="dlg-template">Void Payment</div>
	</ng-template>
	<ng-template #content>
		<div [class.card_loader]="isVoiding"></div>
		@if (errorMessage) {
			<div class="alert alert-danger">
				<strong>{{ errorMessage }}</strong>
			</div>
		}
		<form [formGroup]="componentForm"
			  [hidden]="isVoiding"
			  (ngSubmit)="voidPayment()"
			  #templateForm="ngForm"
              id="voidPaymentForm"
			  class="form-horizontal">
			<div class="row">
				<div class="col-sm-12">
					@if (componentForm.invalid && templateForm.submitted) {
						<gandalf-lib-validation-messages
							[form]="componentForm"
							[requestObj]="voidPaymentRequest"
							[attr.data-test-id]="'practicePayVoidPaymentModalValidationMessages'">
						</gandalf-lib-validation-messages>
					}
				</div>
			</div>
			<div class="form-group" [attr.data-test-id]="'practicePayVoidPaymentModalIDSection'">
				<label class="col-sm-3 control-label">ID</label>
				<div class="col-sm-9">
					<p class="form-control-static">{{ data.paymentId }}</p>
				</div>
			</div>
			<div class="form-group" [attr.data-test-id]="'practicePayVoidPaymentModalPayerSection'">
				<label class="col-sm-3 control-label">Payer</label>
				<div class="col-sm-9">
					<p class="form-control-static">{{ data.payerName }}</p>
				</div>
			</div>
			<div class="form-group" [attr.data-test-id]="'practicePayVoidPaymentModalMethodSection'">
				<label class="col-sm-3 control-label">Method</label>
				<div class="col-sm-9">
					<p class="form-control-static">Credit Card - {{ data.paymentMethodCardType.label }} {{ data.last4CreditCard }}</p>
				</div>
			</div>
			<div class="form-group" [attr.data-test-id]="'practicePayVoidPaymentModalAmountSection'">
				<label class="col-sm-3 control-label">Amount</label>
				<div class="col-sm-9">
					<p class="form-control-static">{{ data.paymentAmount | currency }}</p>
				</div>
			</div>
			<div class="form-group" [attr.data-test-id]="'practicePayVoidPaymentModalReasonSection'">
				<label class="col-sm-3 control-label required">Reason</label>
				<div class="col-sm-9">
					<ejs-textbox class="h-rows-5" revFocusInput [multiline]="true" maxlength="255" formControlName="comments"></ejs-textbox>
					<div>
						{{ componentForm.controls['comments']?.value.length }} of 255 characters
					</div>
				</div>
			</div>
		</form>
	</ng-template>
	<ng-template #footerTemplate>
		@if (!isVoiding) {
			<button
				ejs-button
				cssClass="e-link pull-left margin-left-0"
				(click)="closeModal(true)"
				[attr.data-test-id]="'practicePayVoidManuallyButton'">Void manually
			</button>
			<button
				ejs-button
				iconCss="fa fa-times"
				type="button"
				(click)="closeModal(false)"
				[attr.data-test-id]="'practicePayVoidPaymentModalCancelButton'">Cancel
			</button>
			<button
				ejs-button
                form="voidPaymentForm"
				type="submit"
				[isPrimary]="true"
				[attr.data-test-id]="'practicePayVoidPaymentModalVoidButton'">{{ primaryButtonText }}
			</button>
		}
	</ng-template>
</ejs-dialog>
